"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderDesktop = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./HeaderDesktop.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _HelpModal = require("./components/HelpModal");
var _useHelpModal = require("./hooks/useHelpModal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HeaderDesktop = props => {
  const {
    offerId,
    title,
    subtitle,
    help
  } = props;
  const {
    isHelpModalVisible,
    openHelpModal,
    closeHelpModal
  } = (0, _useHelpModal.useHelpModal)(offerId);
  return /*#__PURE__*/React.createElement("div", {
    className: style['header']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading1, {
    display: "inline-block"
  }, title), !!help && /*#__PURE__*/React.createElement("div", {
    className: style['help']
  }, /*#__PURE__*/React.createElement(_icons.IconActionHelp24, {
    color: "icon-main-default",
    cursor: "pointer",
    onClick: openHelpModal
  }), isHelpModalVisible && /*#__PURE__*/React.createElement(_HelpModal.HelpModal, {
    slides: help,
    onClose: closeHelpModal
  }))), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, subtitle));
};
exports.HeaderDesktop = HeaderDesktop;